import { useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { getContratByCodeId, getEnginsByPersonneCodeId } from "../../hooks/useHooks";
import { Button, Card, Col, Drawer, Image, Input, Row, Select, Spin, Tag } from "antd";
import MSIMPLE from '../../assets/img/attestationdigitale/m.jpg';
import TPVSIMPLE from '../../assets/img/attestationdigitale/tpvsimple.jpg';
import TPVBUS from '../../assets/img/attestationdigitale/tpvbus.jpg';
import VTSIMPLE from '../../assets/img/attestationdigitale/vtsimple.jpg';
import VTBUS from '../../assets/img/attestationdigitale/vtbus.jpg';
import PABUS from '../../assets/img/attestationdigitale/pabus.jpg';
import PASIMPLE from '../../assets/img/attestationdigitale/pasimple.jpg';
import Logo from "../../components/Logo";
import html2canvas from "html2canvas";
import { PDFDocument } from "pdf-lib";
import axiosMultiPartDatainstance from "../../variables/api/axiosMultiPartDatainstance";
import {
    CloseCircleOutlined,
    DownloadOutlined,
    FilterOutlined,
    LeftOutlined,
    RightOutlined,
    SearchOutlined
} from "@ant-design/icons";
import { API_URL, TOKEN } from "../../variables/constants";
import AttestationDigitale from "../production/components/attestation-digitale/AttestationDigitale";
import Fuse from "fuse.js";


const DownloadCertificates = () => {
    const [searchParams] = useSearchParams();
    const iParam = searchParams.get("i");
    const sParam = searchParams.get("s");
    const [engin, setEngin] = useState([]);
    const [contrat, setContrat] = useState();
    const [loading, setLoading] = useState(true);
    const attestationRefs = useRef({});
    const [searchText, setSearchText] = useState("")
    const [logoImagePreviewUrl, setLogoImagePreviewUrl] = useState("")
    const [drawerOpen, setDrawerOpen] = useState(false)
    const [souscripteurs, setSouscripteurs] = useState([])
    const [filteringData, setFilteringData] = useState([]);
    const [selectedSouscripteurs, setSelectedSouscripteurs] = useState([]);
    const [selectedMarques, setSelectedMarques] = useState([]);
    const [selectedImmatriculations, setSelectedImmatriculations] = useState([]);

    console.log(logoImagePreviewUrl)

    const [filteredEngins, setFilteredEngins] = useState([]);
    useEffect(() => {
        if (iParam) {
            getEnginsByPersonneCodeId(sParam, iParam).then((response) => {
                setEngin(response.data);
                setLoading(false);
            });
        }
        if (sParam) {
            getContratByCodeId(sParam).then(res => {
                setContrat(res.data)
                setEngin(res.data.engins)
                setLoading(false);

            });
        }

    }, [iParam, sParam]);

    useEffect(() => {
        if (contrat) {
            fetch(`${API_URL}/api/organisme/logo/${contrat?.organisme?.logo.split("/")[1]}`, {
                headers: {
                    Authorization: `Bearer ${TOKEN}`,
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
                    "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                },
            })
                .then(async (response) => {
                    // convert byte to file
                    const imageBytes = await response.arrayBuffer();
                    const blob = new Blob([imageBytes], { type: "image/png" });
                    const imageUrl = URL.createObjectURL(blob);
                    setLogoImagePreviewUrl(imageUrl);
                    setTimeout(() => {
                        console.log("Preview: ", { logoImagePreviewUrl });
                    }, 1000);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [contrat]);
    console.log(contrat)
    const getTypeAttestatonByEngin = (engin) => {
        if (engin.categorie?.codeCategorie === 'M') return MSIMPLE;
        if (engin.categorie?.codeCategorie === 'TPV') return engin.nombrePlace <= 5 ? TPVSIMPLE : TPVBUS;
        if (engin.categorie?.codeCategorie === 'PA') return engin.nombrePlace <= 5 ? PASIMPLE : PABUS;
        if (engin.categorie?.codeCategorie === 'VT-VL') return VTSIMPLE;
        if (engin.categorie?.codeCategorie === 'VT-C') return VTBUS;
    };

    const getTint = (engin) => {
        if (engin.categorie?.codeCategorie === 'M') {
            return '#fff'
        } else {
            return '#000'
        }
    }

    const getCouleurByEngin = (engin) => {
        const colors = { 'M': 'ROSE', 'TPV': 'VERTE', 'PA': 'JAUNE', 'VT-VL': 'BLEUE', 'VT-C': 'BLEUE' };
        return colors[engin.categorie?.codeCategorie] || 'BLANC';
    };

    const getColor = (engin) => {
        const colors = {
            'M': 'rgba(255, 192, 203, 0.5)',  // Pink
            'TPV': 'rgba(0, 128, 0, 0.5)',    // Green
            'PA': 'rgba(255, 255, 0, 0.5)',   // Yellow
            'VT-VL': 'rgba(0, 0, 255, 0.5)',  // Blue
            'VT-C': 'rgba(0, 0, 255, 0.5)'    // Blue
        };
        return colors[engin.categorie?.codeCategorie] || 'rgba(255, 255, 255, 0.5)'; // Default: Transparent white
    };

    const fuse = new Fuse(engin, {
        keys: ['immatriculation', 'marque', 'personne.nom', 'personne.prenom', 'conducteurHabituel.nom', 'conducteurHabituel.prenom'],
        threshold: 0.3
    })

    useEffect(() => {
        if (searchText.trim() === "") {
            setFilteredEngins(engin);
        } else {
            const results = fuse.search(searchText).map(({ item }) => item);
            console.log(results)
            setFilteredEngins(results);
        }
    }, [searchText]);

    console.log(engin)

    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(4); // Default for large screens

    // Update visible items per page based on screen size
    useEffect(() => {
        const updateItemsPerPage = () => {
            const width = window.innerWidth;
            if (width < 600) setItemsPerPage(1); else if (width < 1024) setItemsPerPage(2); else setItemsPerPage(3);
        };

        updateItemsPerPage();
        window.addEventListener("resize", updateItemsPerPage);
        return () => window.removeEventListener("resize", updateItemsPerPage);
    }, []);

    // Pagination Logic
    const totalItems = engin?.length || 0;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Handle next/prev navigation
    const nextPage = () => setCurrentPage((prev) => (prev + 1 < totalPages ? prev + 1 : prev));
    const prevPage = () => setCurrentPage((prev) => (prev - 1 >= 0 ? prev - 1 : prev));


    const handleExport = async (engin) => {
        try {
            const formData = new FormData();
            const files = [];

            for (const engine of engin) {
                const refForEngin = attestationRefs.current[engine.codeId];
                if (refForEngin) {
                    const canvas = await html2canvas(refForEngin, { scale: 5, useCORS: true, backgroundColor: null });
                    const imgData = canvas.toDataURL('image/png');
                    const pdfDoc = await PDFDocument.create();
                    const imgBytes = await fetch(imgData).then(res => res.arrayBuffer());
                    const pdfImage = await pdfDoc.embedPng(imgBytes);
                    const { width, height } = pdfImage.scale(1);
                    const page = pdfDoc.addPage([width, height]);
                    page.drawImage(pdfImage, { x: 0, y: 0, width, height });

                    const pdfBytes = await pdfDoc.save();
                    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
                    const pdfFile = new File([pdfBlob], `attestation_${engine.codeId}.pdf`, { type: 'application/pdf' });

                    formData.append("certificateFiles", pdfFile);
                    files.push(pdfFile);
                }
            }

            if (files.length === 0) {
                console.error("No valid files to process.");
                return;
            }

            // **using POST and sending FormData**
            const response = await axiosMultiPartDatainstance.post('/api/attestation-digitale/secure-certificates', formData, {
                responseType: 'blob', // Important for handling binary files
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            // Determine if the response is a single PDF or a ZIP
            const contentType = response.headers['content-type'];
            const isZip = contentType === 'application/zip' || contentType === 'application/octet-stream';

            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = isZip ? 'secured_certificates.zip' : files[0].name;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading secured certificates:", error);
        }
    };

    const hasOneEnginAndAvailable = () => {
        if (engin?.length === 1) {
            return engin[0]?.numeroAttestationDigitale !== null
        } else return true
    }

    const [filteredEngin, setFilteredEngin] = useState([])
    useEffect(() => {
        setFilteredEngin(engin)
    }, [engin]);

    const search = () => {
        const resp = fuse.search(searchText).map((result) => result.item)
        console.log('Hai ', resp)
        setFilteredEngin(resp)
        return resp
    }
    useEffect(() => {
        if (searchText === '') {
            setFilteredEngins(engin)
        } else search()
    }, [searchText]);

    useEffect(() => {
        if (filteringData.length === 0) {
            setFilteredEngins(engin);
            return;
        }

        // Combine all selected filter values into a single search string
        const searchQuery = filteringData.map((f) => f.value).join(" ");

        // Apply Fuse search
        console.log(searchQuery)
        const results = fuse.search(searchQuery).map((result) => result.item);
        console.log(results)
        setFilteredEngins(results);
    }, [filteringData, engin]);


    const [marques, setMarques] = useState([])
    const [immatriculations, setImmatriculations] = useState([])
    useEffect(() => {
        if (engin) {
            setSouscripteurs((prevState) => [
                ...prevState,
                ...engin
                    .map((e) => e.conducteurHabituel.nom + " " + e.conducteurHabituel.prenom)
                    .filter((name) => !prevState.includes(name)) // Avoid duplicates
            ]);

            setMarques((prevState) => [
                ...prevState,
                ...engin
                    .map((e) => e.marque)
                    .filter((marque) => !prevState.includes(marque)) // Avoid duplicates
            ]);

            setImmatriculations((prevState) => [
                ...prevState,
                ...engin
                    .map((e) => e.immatriculation)
                    .filter((immatriculation) => !prevState.includes(immatriculation)) // Avoid duplicates
            ]);
        }
    }, [engin]);


    const handleFilterChange = (value, filterElement) => {
        setFilteringData((prev) => {
            return [
                ...prev.filter((item) => item.filterElement !== filterElement),
                ...value.map((val) => ({ filterElement, value: val }))
            ];
        });
    };

    const removeFilter = (filterElement, value) => {
        setFilteringData((prev) => prev.filter(item => !(item.filterElement === filterElement && item.value === value)));
    };

    const clearFilters = () => {
        setFilteringData([]);
        setSelectedSouscripteurs([]);
        setSelectedMarques([]);
        setSelectedImmatriculations([]);
    };

    return (
        <div
            style={{
                height: '100vh',
                background: 'linear-gradient(to bottom, #ddeefb, #cce0f5, #f8f9fa, #e9ecef)',
                textAlign: 'center',
                width: '100%',
                alignItems: 'center',
                overflow: 'hidden',

            }}>
            {/* Logo Section */}
            <div style={{
                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
            >
                <div style={{ width: '150px' }}>
                    <Logo />
                </div>

                <div style={{
                    width: '50%',
                }}
                >
                    <Input
                        style={{
                            width: '80%',
                            maxWidth: '600px',
                            borderRadius: '12px'
                        }}
                        placeholder="Rechercher..."
                        size={"large"}
                        prefix={<SearchOutlined className="text-gray-400" />}
                        suffix={searchText && (<CloseCircleOutlined
                            className="text-gray-400 cursor-pointer hover:text-gray-600"
                            onClick={() => {
                                setSearchText("")
                                setFilteredEngin(engin)
                            }}
                        />)}
                        value={searchText}
                        onChange={(e) => {
                            setSearchText(e.target.value)
                        }}
                    />

                </div>

                <div style={{ width: "100px", textAlign: "right" }}>
                    {engin?.length > 0 && hasOneEnginAndAvailable() && (
                        <Button
                            size="large"
                            style={{
                                border: "none",
                                color: "gray",
                                fontSize: "16px",
                                fontWeight: "bold",
                                transition: "0.3s ease-in-out",
                            }}
                            onClick={() => {
                                engin?.length >= 2 ? handleExport(engin) : handleExport(engin);
                            }}
                            icon={<DownloadOutlined size={30} />}
                        />
                    )}
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", justifyContent: 'center', }}>
                {/* Filtres Button */}
                <Button
                    style={{
                        padding: "12px 20px",
                        borderRadius: "12px",
                        background: "linear-gradient(135deg, #007bff, #0056b3)",
                        border: "none",
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "bold",
                        transition: "0.3s ease-in-out",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                    }}
                    size="large"
                    onClick={() => setDrawerOpen((prevState) => !prevState)}
                    icon={<FilterOutlined />}
                >
                    Filtres
                </Button>

                {/* Display Active Filters as Tags */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
                    {filteringData.map((filter, index) => (
                        <Tag
                            key={index}
                            closable
                            onClose={() => removeFilter(filter.filterElement, filter.value)}
                            color="blue"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontSize: "14px",
                                padding: "6px 12px",
                                borderRadius: "10px",
                                transition: "0.3s ease-in-out",
                            }}
                        >
                            <strong>{filter.filterElement}:</strong> {filter.value}
                        </Tag>
                    ))}
                    {filteringData.length > 0 && (
                        <Button
                            type="text"
                            icon={<CloseCircleOutlined style={{ color: "red" }} />}
                            onClick={clearFilters}
                            style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "red",
                                transition: "0.3s ease-in-out",
                            }}
                        >
                            Effacer tout
                        </Button>
                    )}
                </div>

                {/* Filter Drawer */}
                <Drawer
                    title="Filtres"
                    onClose={() => setDrawerOpen(false)}
                    open={drawerOpen}
                    placement="left"
                    width={350}
                    bodyStyle={{
                        padding: "24px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        background: "#f8f9fa",
                        transition: "all 0.3s ease-in-out",
                    }}
                    headerStyle={{
                        background: "#fff",
                        padding: "16px 24px",
                        borderBottom: "1px solid #e0e0e0",
                        fontWeight: "bold",
                        fontSize: "18px",
                    }}
                    closeIcon={<CloseCircleOutlined style={{ fontSize: "18px", color: "#333" }} />}
                    style={{
                        boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.1)",
                        transition: "transform 0.3s ease-in-out",
                    }}
                >
                    <Select
                        mode="multiple"
                        placeholder="Sélectionner un souscripteur"
                        options={souscripteurs?.map((s) => ({ value: s, label: s }))}
                        value={selectedSouscripteurs}
                        onChange={(value) => {
                            setSelectedSouscripteurs(value);
                            handleFilterChange(value, "souscripteur");
                        }}
                        style={{ width: "100%" }}
                    />

                    <Select
                        mode="multiple"
                        placeholder="Sélectionner une marque"
                        options={marques?.map((m) => ({ value: m, label: m }))}
                        value={selectedMarques}
                        onChange={(value) => {
                            setSelectedMarques(value);
                            handleFilterChange(value, "marque");
                        }}
                        style={{ width: "100%" }}
                    />

                    <Select
                        mode="multiple"
                        placeholder="Sélectionner une immatriculation"
                        options={immatriculations?.map((i) => ({ value: i, label: i }))}
                        value={selectedImmatriculations}
                        onChange={(value) => {
                            setSelectedImmatriculations(value);
                            handleFilterChange(value, "immatriculation");
                        }}
                        style={{ width: "100%" }}
                    />
                </Drawer>

            </div>
            {/* Gradient Text for H1 */
            }
            <h3
                style={{
                    fontSize: '26px',
                    fontWeight: 'bold',
                    background: 'linear-gradient(to right, #007bff, #2a52be, #00008b)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',

                }}
            >
                Vos attestations automobile digitales
            </h3>

            {/* Loading Indicator */
            }
            {
                loading ? (<Spin size="large" />) : (<>
                    {/* Card Display with Pagination */}
                    <div style={{
                        width: "100vw", marginBottom: "20px", alignItems: 'center',
                        marginTop: '70px',
                        justifyContent: 'center'
                    }}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: '40px'
                        }}>
                            {/* Previous Button */}
                            <Button
                                type="text"
                                icon={<LeftOutlined />}
                                disabled={currentPage === 0}
                                onClick={prevPage}
                                style={{ fontSize: "20px", marginRight: "10px" }}
                            />

                            {/* Cards */}

                            <div style={{ width: '90%', height: '500px' }}>
                                <Row gutter={10} justify="center">
                                    {filteredEngin?.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage).map((e) => {
                                        const isBlurred = e.numeroAttestationDigitale === null;

                                        return (<Col
                                            key={e.codeId}
                                            xs={24} sm={12} md={8} lg={6}
                                            style={{ textAlign: 'center', marginBottom: '10px', position: 'relative' }}
                                        >
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                <>
                                                    <div>
                                                        <Card hoverable style={{
                                                            border: "1px solid #e8e8e8",
                                                            borderRadius: "5px",
                                                            width: '300px',
                                                            background: '#fff',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: 0,
                                                            margin: 0,
                                                        }}>


                                                            <Image src={logoImagePreviewUrl} style={{
                                                                width: '100px', borderRadius: '5px',
                                                            }} />

                                                            <div style={{ flex: 1, marginLeft: '10px' }}>
                                                                <p style={{
                                                                    fontSize: '18px',
                                                                    fontWeight: 'bold',
                                                                    color: '#1890ff',
                                                                    textAlign: 'center',
                                                                    padding: '5px',
                                                                    border: '2px solid #1890ff',
                                                                    display: 'inline-block',
                                                                    borderRadius: '5px',
                                                                    marginTop: '10px',
                                                                    width: '100%',
                                                                    boxSizing: 'border-box',
                                                                }}>
                                                                    {e.immatriculation}
                                                                </p>
                                                                {
                                                                    isBlurred ? (
                                                                        <p style={{
                                                                            fontSize: '14px',
                                                                            color: '#999',
                                                                            textAlign: 'center',
                                                                            marginTop: '10px',
                                                                            padding: '5px',
                                                                            backgroundColor: '#ffe0b2',
                                                                            borderRadius: '5px',
                                                                            fontStyle: 'italic',
                                                                        }}>
                                                                            Votre attestation automobile digitale n'est
                                                                            pas encore disponible.
                                                                        </p>
                                                                    ) : (
                                                                        <Button style={{
                                                                            background: getColor(e)
                                                                        }} onClick={() => handleExport([e])}>
                                                                            Télécharger
                                                                        </Button>
                                                                    )
                                                                }

                                                            </div>

                                                        </Card>
                                                    </div>
                                                </>
                                                <div style={{
                                                    /*  position: 'absolute',
                                                      top: '-9999px',
                                                      left: '-9999px',
                                                      opacity: 0,*/
                                                    marginTop: '-250px'
                                                }}>
                                                    <AttestationDigitale
                                                        engin={e}
                                                        contrat={contrat}
                                                        couleur={getCouleurByEngin(e)}
                                                        background={getTypeAttestatonByEngin(e)}
                                                        tint={getTint(e)}
                                                        ref={(el) => (attestationRefs.current[e.codeId] = el)}
                                                        style={{
                                                            filter: isBlurred ? 'blur(5px)' : 'none',
                                                            pointerEvents: isBlurred ? 'none' : 'auto',
                                                        }}
                                                    />
                                                </div>


                                            </div>
                                        </Col>);
                                    })}
                                </Row>
                            </div>


                            {/* Next Button */}
                            <Button
                                type="text"
                                icon={<RightOutlined />}
                                disabled={currentPage === totalPages - 1}
                                onClick={nextPage}
                                style={{ fontSize: "20px", marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* Download Button */}

                </>)
            }
        </div>)
        ;

};

export default DownloadCertificates;
